import { NgModule } from '@angular/core';
import { RouterModule, Routes } from "@angular/router";
import { AllComponent } from '../all/all.component';
import { VisionbooksPageComponent } from '../visionbooks-page/visionbooks-page.component';
import { FacestarPageComponent } from '../facestar-page/facestar-page.component';
import { LoveStickyPageComponent } from '../love-sticky-page/love-sticky-page.component';
import { AboutUsPageComponent } from '../about-us-page/about-us-page.component';
import { PressPageComponent } from '../press-page/press-page.component';
import { ContactPageComponent } from '../contact-page/contact-page.component';
import { ArComponent } from '../ar/ar.component';

const appRoutes: Routes = [
  {
    path: "",
    component: AllComponent
  },
  {
    path: "home",
    component: AllComponent
  },
  {
    path: "aboutUs",
    component: AboutUsPageComponent
  },
  {
    path: "press",
    component: PressPageComponent
  },
  {
    path: "contact",
    component: ContactPageComponent
  },
  {
    path: "visionbooks",
    component: VisionbooksPageComponent
  },
  {
    path: "facestar",
    component: FacestarPageComponent
  },
  {
    path: "lovesticky",
    component: LoveStickyPageComponent
  },
  {
    path: "ar",
    component: ArComponent
  },
  {
    path: "**",
    component: AllComponent
  },
]

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing/app-routing.module.ts